var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zt-page-content"},[_c('Txgl',{key:_vm.tabIndex,attrs:{"price_type":_vm.tabIndex}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }